"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppErrorCode = exports.isCaptchaError = exports.isAppError = void 0;
const CaptchaApplicationErrorCode_1 = require("../enums/orders/CaptchaApplicationErrorCode");
const ValidationOrderErrorCode_1 = require("../enums/orders/ValidationOrderErrorCode");
const isAppError = (httpError) => {
    const errorCode = (0, exports.getAppErrorCode)(httpError);
    return (!!errorCode &&
        [...Object.values(ValidationOrderErrorCode_1.ValidationOrderErrorCode), ...Object.values(CaptchaApplicationErrorCode_1.CaptchaApplicationErrorCode)].includes(errorCode));
};
exports.isAppError = isAppError;
const isCaptchaError = (httpError) => {
    return ((0, exports.isAppError)(httpError) &&
        Object.values(CaptchaApplicationErrorCode_1.CaptchaApplicationErrorCode).includes((0, exports.getAppErrorCode)(httpError)));
};
exports.isCaptchaError = isCaptchaError;
const getAppErrorCode = (httpError) => { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = httpError === null || httpError === void 0 ? void 0 : httpError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details) === null || _c === void 0 ? void 0 : _c.applicationError) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : null; };
exports.getAppErrorCode = getAppErrorCode;
//# sourceMappingURL=appError.js.map